import { BRAND, IMAGES, SOCIALS } from "@/lib/constants";
import { Mail, Phone, MapPin, Instagram, Facebook, Music2 } from "lucide-react";

export default function Footer() {
  return (
    <footer className="relative bg-emerald-deep border-t border-gold-soft mt-32" id="contact" data-testid="site-footer">
      <div className="absolute top-0 left-0 right-0 gold-line" />
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 pt-20 pb-10">
        <div className="grid lg:grid-cols-12 gap-16 mb-20">
          <div className="lg:col-span-5">
            <img src={IMAGES.logo} alt="Cozy Keys" className="h-20 w-20 rounded-full object-cover ring-1 ring-gold mb-8" />
            <h3 className="font-serif-display text-5xl md:text-6xl text-ivory leading-none mb-6">
              Cozy <span className="text-gold italic">Keys</span>
            </h3>
            <p className="text-ivory-muted max-w-md text-base leading-relaxed">
              A private chauffeur service crafted for the moments that matter — discreet, classy, and always on time. Serving {BRAND.city} and surrounding communities.
            </p>
          </div>

          <div className="lg:col-span-3">
            <div className="overline mb-5">Reach us</div>
            <ul className="space-y-4 text-ivory-muted text-sm">
              <li className="flex items-start gap-3">
                <Phone className="h-4 w-4 text-gold mt-0.5" />
                <a href={`tel:${BRAND.phone}`} className="hover:text-ivory" data-testid="footer-phone">{BRAND.phoneVanity}<br/><span className="text-xs opacity-60">{BRAND.phone}</span></a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="h-4 w-4 text-gold mt-0.5" />
                <a href={`mailto:${BRAND.email}`} className="hover:text-ivory break-all" data-testid="footer-email">{BRAND.email}</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="h-4 w-4 text-gold mt-0.5" />
                <span>{BRAND.city}<br/><span className="text-xs opacity-60">By reservation only</span></span>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <div className="overline mb-5">Services</div>
            <ul className="space-y-3 text-ivory-muted text-sm">
              <li><a href="/#services" className="hover:text-gold">Airport Transfer</a></li>
              <li><a href="/#date-night" className="hover:text-gold">Date Night</a></li>
              <li><a href="/#prom" className="hover:text-gold">Prom Set-Up</a></li>
              <li><a href="/#services" className="hover:text-gold">Concerts</a></li>
              <li><a href="/#services" className="hover:text-gold">Drop-off / Pick-up</a></li>
              <li><a href="/rentals" className="hover:text-gold">Self-Drive Rentals</a></li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <div className="overline mb-5">Follow</div>
            <div className="flex gap-3">
              <a href={SOCIALS.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="h-10 w-10 grid place-items-center border border-gold-soft text-gold hover:bg-gold hover:text-void transition" data-testid="footer-ig">
                <Instagram className="h-4 w-4" />
              </a>
              <a href={SOCIALS.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="h-10 w-10 grid place-items-center border border-gold-soft text-gold hover:bg-gold hover:text-void transition" data-testid="footer-fb">
                <Facebook className="h-4 w-4" />
              </a>
              <a href={SOCIALS.tiktok} target="_blank" rel="noopener noreferrer" aria-label="TikTok" className="h-10 w-10 grid place-items-center border border-gold-soft text-gold hover:bg-gold hover:text-void transition" data-testid="footer-tiktok">
                <svg viewBox="0 0 24 24" fill="currentColor" className="h-4 w-4"><path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.27a8.16 8.16 0 0 0 4.77 1.52V6.34a4.85 4.85 0 0 1-1.84-.43z"/></svg>
              </a>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-gold-soft flex flex-col md:flex-row md:items-center justify-between gap-4 text-xs text-ivory-muted">
          <div>© {new Date().getFullYear()} {BRAND.legal}. All rights reserved.</div>
          <div className="tracking-[0.3em] uppercase text-[10px]">Pittsburgh · Private Chauffeur · By Reservation</div>
        </div>
      </div>
    </footer>
  );
}
